export interface TopLevelCategory {
  name: string;
  path: string;
  id: string;
  svgFileName: string;
}

export const TOP_LEVEL_CATEGORIES: TopLevelCategory[] = [
  {
    name: "Capacitors",
    path: "/electronic-parts/passive-components/capacitors",
    id: "4166",
    svgFileName: "/icons/part-categories/capacitors.svg",
  },
  {
    name: "Circuit Protection",
    path: "/electronic-parts/circuit-protection",
    id: "4569",
    svgFileName: "/icons/part-categories/circuit_protection.svg",
  },
  {
    name: "Connectors",
    path: "/electronic-parts/connectors",
    id: "4364",
    svgFileName: "/icons/part-categories/connectors.svg",
  },
  {
    name: "Diodes",
    path: "/electronic-parts/discrete-semiconductors/diodes",
    id: "4220",
    svgFileName: "/icons/part-categories/diodes.svg",
  },
  {
    name: "Hardware",
    path: "/electronic-parts/tools-and-supplies/hardware-fasteners",
    id: "4952",
    svgFileName: "/icons/part-categories/hardware.svg",
  },
  {
    name: "ICs",
    path: "/electronic-parts/integrated-circuits-ics",
    id: "4215",
    svgFileName: "/icons/part-categories/ics.svg",
  },
  {
    name: "Inductors",
    path: "/electronic-parts/passive-components/inductors",
    id: "4190",
    svgFileName: "/icons/part-categories/inductors.svg",
  },
  {
    name: "Oscillators",
    path: "/electronic-parts/passive-components/crystals-and-oscillators/oscillators",
    id: "4201",
    svgFileName: "/icons/part-categories/oscillators.svg",
  },
  {
    name: "Resistors",
    path: "/electronic-parts/passive-components/resistors",
    id: "4173",
    svgFileName: "/icons/part-categories/resistors.svg",
  },
  {
    name: "Sensors",
    path: "/electronic-parts/sensors",
    id: "5510",
    svgFileName: "/icons/part-categories/sensors.svg",
  },
  {
    name: "Switches",
    path: "/electronic-parts/electromechanical/switches",
    id: "4809",
    svgFileName: "/icons/part-categories/switches.svg",
  },
  {
    name: "Transistors",
    path: "/electronic-parts/discrete-semiconductors/transistors",
    id: "4228",
    svgFileName: "/icons/part-categories/transistors.svg",
  },
];
